import React from 'react';
import { Droppable, Draggable } from "react-beautiful-dnd";
import ListingCard from '../Components/ListingCard';

const form_data = {
    unassigned: 'Unassigned listings',
    listings: 'listings',
    plans: 'plans',
    plan_type: 'PLAN'
}

const RenderKeywordListings = ({ listings, set_add_keyword, id, type='LISTING' }) => {

    return (
        <Droppable droppableId={id} type={type}>
            {(provided) => {
                return (
                    <div
                    style={{minHeight: 10, padding: 10}}
                        ref={provided.innerRef}
                    >
                        {listings.map((item, index) => {
                            return (
                                <Draggable
                                    key={type === form_data.plan_type ? item.plan_uuid : item.listing_id}
                                    draggableId={type === form_data.plan_type ? item.plan_uuid : item.listing_id}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div >
                                            <div ref={provided.innerRef} {...provided.draggableProps} className={`col-12 bottom_margin`}>
                                                <ListingCard item={item} index={index} provided={provided}
                                                    // handleAddKeyword={keyword === form_data.unassigned ? (value) => set_add_keyword(value) : null}
                                                    // can_remove_keyword={keyword !== form_data.unassigned}
                                                />
                                            </div>
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                );
            }}
        </Droppable>
    )
}

export default RenderKeywordListings;